import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UserIdleModule } from 'angular-user-idle';
import { FlexLayoutModule } from '@angular/flex-layout';

import { SharedModule } from './shared/shared.module';
import { OrganizationAdminModule } from './modules/organization-admin/organization-admin.module';
import { UsersModule } from './modules/users/users.module';
import { SuperAdminModule } from './modules/super-admin/super-admin.module';
import { AttendancesModule } from './modules/attendance/attendances.module';
import { HolidaysModule } from './modules/holidays/holidays.module';
import { LeavesModule } from './modules/leaves/leaves.module';
import { ShiftsModule } from './modules/shifts/shifts.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { LeaveTypeModule } from './modules/leave-type/leave-type.module';
import { OrgLeaveModule } from './modules/org-leave/org-leave.module';
import { ScreenshotModule } from './modules/screenshot/screenshot.module';
import { SettingsModule } from './modules/settings/settings.module';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { SigninComponent } from './core/signin/signin.component';
import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';
import { AccesDeniedComponent } from './core/acces-denied/acces-denied.component';

import { AuthenticationService } from './auth/services/authentication.service';
import { AuthTokenInterceptor } from './auth/services/authToken.service';
import { AuthGuard } from './auth/services/auth.guard';
import { LoaderService } from './auth/services/loader.service';
import { LoaderInterceptor } from './auth/services/loader.interceptor';
import { OrganizationAdminService } from './modules/organization-admin/services/organization-admin.service'
import { UsersService } from './modules/users/services/users.service';
import { CommonService } from './shared/services/common.service';
import { AttendancesService } from './modules/attendance/services/attendances.service';
import { HolidaysService } from './modules/holidays/services/holidays.service';
import { LeavesService } from './modules/leaves/services/leaves.service';
import { LeaveTypesService } from './modules/leave-type/services/leave-types.service';
import { OrgLeavesService } from './modules/org-leave/services/org-leaves.service';
import { ScreenshotService } from './modules/screenshot/services/screenshot.service';
import { ReportsService } from './modules/reports/services/reports.service';
import { ExcelService } from './shared/services/excel.service';

import { AppDateAdapter,APP_DATE_FORMATS } from './shared/components/datepicker-format/datepicker-format'
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ForgotPasswordComponent } from './core/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/reset-password/reset-password.component';
import { WfhModule } from './modules/wfh/wfh.module';
import { WfhComponent } from './modules/wfh/wfh.component';
import { WfhService } from './modules/wfh/services/wfh.service';
import { UploadFilesService } from './modules/upload-files/services/upload-files.service';
import { UploadFilesModule } from './modules/upload-files/upload-files.module';

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    PageNotFoundComponent,
    AccesDeniedComponent,
    LoaderComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
  
    // BreadcrumbComponent,
 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FlexLayoutModule,
    SharedModule,
    SuperAdminModule,
    OrganizationAdminModule,
    UsersModule,
    AttendancesModule,
    HolidaysModule,
    LeavesModule,
    ShiftsModule,
    DashboardModule,
    LeaveTypeModule,
    OrgLeaveModule,
    ScreenshotModule,
    SettingsModule,
    WfhModule,
    UploadFilesModule,
    UserIdleModule.forRoot({idle: 60*60*24, timeout: 60*60*24, ping: 60*60*24}),
  ],
  providers: [
    AuthGuard, 
    AuthenticationService,
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    OrganizationAdminService, 
    UsersService,
    CommonService,
    AttendancesService,
    HolidaysService,
    LeavesService,
    LeaveTypesService,
    OrgLeavesService,
    ScreenshotService,
    ReportsService,
    ExcelService,
    WfhService,
    UploadFilesService,

  ],
  bootstrap: [AppComponent],
  entryComponents:[AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
